import { render, staticRenderFns } from "./submit_select_products.vue?vue&type=template&id=5128dbca&scoped=true"
import script from "./submit_select_products.vue?vue&type=script&lang=js"
export * from "./submit_select_products.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5128dbca",
  null
  
)

export default component.exports